import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ContentAndStatus } from '../../Models/OtherClasses';
import { BaseService } from "../BaseService";
import { UrlService } from "../UrlService";

@Injectable()
export class PaymentService {
	private url: string;

	constructor(
		private myBaseService: BaseService,
		private urlService: UrlService
	) {
		this.url = urlService.getURL('Payment');
	}

	getAnonToken(): Observable<TooBig4Car.Logic.PublicPaymentSystemInfoVM> {

		return this.myBaseService.getPlain(this.url + '/AnonToken', 'Failed to get token');
	}

	getPublicData(id: System.Guid): Observable<ContentAndStatus<TooBig4Car.Logic.PublicPaymentInfoVM>> {
		return this.myBaseService.getPlainErrorOptionWithStatusCode(this.url + '/PublicOwed/' + (id || ''), 'Failed to get pricing data', true);
	}
	getPublicDataForVM(vm: TooBig4Car.Logic.ReservationQuestionaireVM): Observable<TooBig4Car.Logic.PublicPaymentInfoVM> {
		return this.myBaseService.post(vm, this.url + '/ReservationPricingInfo', false);
	}
	getCustomerToken(id: System.Guid): Observable<TooBig4Car.Logic.PublicPaymentSystemInfoVM> {
		return this.myBaseService.getPlain(this.url + '/CustomerTokenForCustomer/' + (id || ''), 'Failed to get token');
	}
	confirmPaymentNonce(custid: System.Guid, nonce: string): Observable<string> {
		return this.myBaseService.post(null, this.url + '/ConfirmToken/' + (custid || '') + '/' + (nonce || ''), true);
	}
	runPublicPayment(nonce: string, payment: TooBig4Car.Logic.PublicPaymentInfoVM): Observable<string> {
		return this.myBaseService.post(payment, this.url + '/RunPublicPayment/' + (nonce || ''), true);
	}
	runBTPayment(nonce: string, payment: TooBig4Car.Logic.Payment): Observable<TooBig4Car.Logic.Payment> {
		return this.myBaseService.save(payment, this.url + '/RunBTPayment/' + (nonce || ''));
	}
	loadAll(): Observable<TooBig4Car.Logic.Payment[]> {
		return this.myBaseService.loadAll(this.url);
	}
	save(tempItem: TooBig4Car.Logic.ObjectBase): Observable<TooBig4Car.Logic.Payment> {
		return this.myBaseService.save(tempItem, this.url);
	}
	deleteItem(id: System.Guid): Observable<boolean> {
		return this.myBaseService.deleteItem(id, this.url);
	}
	getEdit(id: System.Guid): Observable<TooBig4Car.Logic.Payment> {
		return this.myBaseService.getEdit(id, this.url);
	}
	get(id: System.Guid): Observable<TooBig4Car.Logic.Payment> {
		return this.myBaseService.get(id, this.url);
	}
	search(searchTerm: string): Observable<TooBig4Car.Logic.Payment[]> {
		return this.myBaseService.post(searchTerm, this.url + '/Search', false);
	}
}

